import { Box, Button, Flex, Icon, Input, InputGroup, InputLeftAddon, TableContainer } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import * as T from '../../../components/Table'
import { ValidacaoCaricaturaLista } from './ValidacaoCaricaturaLista'
import { useForm } from 'react-hook-form'
import { FaSearch } from 'react-icons/fa'
import { useValidacaoCaricaturaContext } from '../../../contexts/ValidacaoCaricaturaProvider'

export const ValidacaoDeCaricatura = () => {
  const { register, handleSubmit } = useForm()

  const { onFilter, query } = useValidacaoCaricaturaContext()

  async function handleSubmitFilter(data) {
    onFilter(data)
  }

  return (
    <>
      <Box experimental_spaceY={4}>
        <HeadingPages name="Validação de Caricatura" />

        <Flex maxW="500px" w="100%" mx="auto" alignItems="flex-end" gap={5} as="form" onSubmit={handleSubmit(handleSubmitFilter)}>
          <InputGroup size="sm">
            <InputLeftAddon children="Pesquisar pedido" as="label" htmlFor="pedido" />
            <Input id="pedido" type={'pedido'} placeholder={'Pedido'} {...register('pedido')} />
          </InputGroup>

          <Button
            fontSize="12px"
            fontWeight="normal"
            size="sm"
            maxW="147px"
            bgColor="#378BBF"
            w="100%"
            type="submit"
            colorScheme="blue"
            leftIcon={<Icon as={FaSearch} />}
            isLoading={query.isLoading || query.isFetching}
          >
            Filtrar
          </Button>
        </Flex>

        <TableContainer overflowX="auto" maxW="1300px" w="100%" mx="auto">
          <T.Table>
            <T.Thead>
              <T.Tr>
                <T.Th>Pedido</T.Th>
                <T.Th>Quantidade</T.Th>
                <T.Th>Ciente</T.Th>
                <T.Th>Prazo</T.Th>
              </T.Tr>
            </T.Thead>
            <T.Tbody>
              <ValidacaoCaricaturaLista />
            </T.Tbody>
          </T.Table>
        </TableContainer>
      </Box>
    </>
  )
}
